module.exports = __webpack_public_path__ + "static/media/facebook-link.cf43b2e7.svg";